<template>
  <div class="domain-tabs-wrap">
    <div class="domain-tabs" role="tablist">
      <router-link
        v-for="tab in tabs"
        :key="tab.to"
        :to="tab.to"
        class="dtab"
        :class="{ active: isActive(tab) }"
        role="tab"
      >
        {{ tab.label }}
      </router-link>
    </div>
    <p v-if="hint" class="domain-hint">{{ hint }}</p>
  </div>
</template>

<script>
import { useRoute } from 'vue-router'

export default {
  name: 'DomainTabs',
  props: {
    tabs: { type: Array, required: true },
    hint: { type: String, default: '' },
  },
  setup() {
    const route = useRoute()
    const isActive = (tab) => {
      if (tab.exact) return route.path === tab.to
      const match = tab.match || [tab.to]
      return match.some((m) => route.path === m || route.path.startsWith(`${m}/`))
    }
    return { isActive }
  },
}
</script>

<style scoped>
.domain-tabs-wrap {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 14px;
}
.domain-tabs {
  display: inline-flex;
  align-self: flex-start;
  flex-wrap: wrap;
  background: #f3f5f8;
  border-radius: 8px;
  padding: 3px;
  gap: 2px;
}
.dtab {
  border: 0;
  background: transparent;
  color: #9aa5b5;
  font-size: 11px;
  font-weight: 700;
  padding: 7px 12px;
  border-radius: 6px;
  text-decoration: none;
  font-family: inherit;
}
.dtab.active {
  background: #fff;
  color: var(--mp-accent);
  box-shadow: 0 2px 6px rgba(52, 65, 93, 0.08);
}
.domain-hint {
  margin: 0;
  font-size: 12px;
  color: var(--mp-text-muted);
}

@media (max-width: 768px) {
  .domain-tabs {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    flex-wrap: nowrap;
  }
  .dtab {
    flex: 0 0 auto;
    white-space: nowrap;
  }
}
</style>
